
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Learn how to handle failed payments, implement retry strategies, and provide a good user experience.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Handling failed payments' subtitle='Implement retry strategies and handle failures gracefully' mdxType="Header" />
    <h4 {...{
      "id": "retrying-a-payment"
    }}>{`Retrying a payment`}</h4>
    <p>{`To retry a failed payment, call `}<inlineCode parentName="p">{`/payment_initiation/payment/create`}</inlineCode>{` again with the same `}<inlineCode parentName="p">{`recipient_id`}</inlineCode>{`, `}<inlineCode parentName="p">{`user_id`}</inlineCode>{`, and `}<inlineCode parentName="p">{`amount`}</inlineCode>{`. `}<inlineCode parentName="p">{`/payment_initiation/payment/create`}</inlineCode>{` is not idempotent -- each call creates a new payment -- so always verify the status of previous attempts before initiating a retry, to avoid creating duplicate successful payments.`}</p>
    <p>{`If you have reached the limit for retry attempts, or the error is not immediately retryable, you should clearly explain the payment failure to your user and offer alternative payment methods or funding options.`}</p>
    <h4 {...{
      "id": "retryable-payment-failures"
    }}>{`Retryable payment failures`}</h4>
    <p>{`The following failures are temporary and can be successfully retried. `}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`PAYMENT_STATUS_FAILED`}</inlineCode></strong>{` is typically due to a transient issue, such as temporary network problems or bank system maintenance. If you experience this status, it is recommended to make one or two retry attempts immediately. Limit the number of retry attempts to avoid causing a negative customer experience.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`PAYMENT_STATUS_BLOCKED`}</inlineCode></strong>{` indicates the payment was blocked by Plaid. This is typically due to regulatory or compliance reasons. Once the compliance issue is resolved, the payment can be retried. `}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`PAYMENT_STATUS_INSUFFICIENT_FUNDS`}</inlineCode></strong>{` indicates the payment failed due to insufficient funds. Once the user has sufficient funds, the payment can be retried. If you experience this status, it is recommended to tell the user what happened and to give them the option to trigger a retry, or make a new payment, once they have added funds.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "retrying-a-payment",
        level: 4,
        title: "Retrying a payment",
      },
{
        id: "retryable-payment-failures",
        level: 4,
        title: "Retryable payment failures",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
